import { render, staticRenderFns } from "./ProconNumberOfComplaintsSixMonths.container.vue?vue&type=template&id=26c4d11e&"
import script from "./ProconNumberOfComplaintsSixMonths.container.vue?vue&type=script&lang=ts&"
export * from "./ProconNumberOfComplaintsSixMonths.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports